<template>
  <div class="web-bq-cms-wrap cms-wrap">
    <template v-if="$route.params.key === 'home' || $route.params.key === 'home-mb'">
      <QuickRegister />
    </template>
  </div>
</template>

<script>
import QuickRegister from '@/components/QuickRegister.vue';


export default {
  name: "WebBQCms",
  components: { QuickRegister },
  data() {
    return {};
  },
  mounted() {
    let key = this.$route.params.key;
    let fakeURL = this.$route.fullPath;
    let goFake = (url) => {
      window.history.pushState(null, '', url);
      setTimeout(() => {
        window.history.pushState(null, '', url);
      }, 100);
      setTimeout(() => {
        window.history.pushState(null, '', url);
      }, 300);
      setTimeout(() => {
        window.history.pushState(null, '', url);
      }, 500);
    }
    //去除开头的webbqcms
    if (key === 'home') {
      fakeURL = fakeURL.replace(new RegExp(`^/${process.env.VUE_APP_WEBBQCMS_URL}/home`), process.env.VUE_APP_BASE_URL);
      goFake(fakeURL)
    } else if (key === 'home-mb') {
      fakeURL = fakeURL.replace(new RegExp(`^/${process.env.VUE_APP_WEBBQCMS_URL}/home-mb`), process.env.VUE_APP_BASE_URL);
      goFake(fakeURL)
    }
  },
  methods: {},
}
</script>

<style lang="scss" scoped></style>